import { DIVERGING_A, DIVERGING_B, sequentialColor } from "@gazelab/analysis";

const rgb = (c: readonly number[]) => `rgb(${c[0]},${c[1]},${c[2]})`;

/** Porcentaje legible con 2 cifras significativas (p. ej. 0.17 %), en vez de notación exponencial. */
function fmtMass(v: number): string {
  if (!(v > 0)) return "0 %";
  return `${Number((v * 100).toPrecision(2)).toLocaleString("es-MX", { maximumSignificantDigits: 2 })} %`;
}

export function sequentialGradientCss(): string {
  const stops = Array.from({ length: 9 }, (_, i) => {
    const t = i / 8;
    return `${rgb(sequentialColor(0.15 + 0.85 * t))} ${Math.round(t * 100)}%`;
  });
  return `linear-gradient(to right, ${stops.join(", ")})`;
}

export function SequentialLegend({ max }: { max: number }) {
  return (
    <div className="text-xs text-slate-600" aria-label="Leyenda de densidad">
      <div className="mb-1 font-medium text-slate-700">Distribución de atención estimada (misma escala en ambos grupos)</div>
      <div className="h-3 w-full max-w-sm rounded" style={{ background: sequentialGradientCss() }} />
      <div className="flex max-w-sm justify-between">
        <span>baja</span>
        <span>
          máx. {fmtMass(max)} de la masa por celda
        </span>
      </div>
    </div>
  );
}

export function DivergingLegend({ maxAbs, threshold, groupA, groupB }: { maxAbs: number; threshold: number; groupA: string; groupB: string }) {
  return (
    <div className="text-xs text-slate-600" aria-label="Leyenda de diferencia">
      <div className="mb-1 font-medium text-slate-700">Diferencia relativa A − B (escala simétrica)</div>
      <div
        className="h-3 w-full max-w-sm rounded"
        style={{ background: `linear-gradient(to right, ${rgb(DIVERGING_B)}, rgba(255,255,255,0) 50%, ${rgb(DIVERGING_A)})` }}
      />
      <div className="flex max-w-sm justify-between gap-2">
        <span>más relativo en {groupB}</span>
        <span>0</span>
        <span>más relativo en {groupA}</span>
      </div>
      <p className="mt-1">
        Umbral visible: diferencias menores al {Math.round(threshold * 100)} % del máximo absoluto ({fmtMass(maxAbs)} por celda) no se colorean.
      </p>
    </div>
  );
}
